import { render, staticRenderFns } from "./KmNextRevision.vue?vue&type=template&id=79e8bc5a&scoped=true"
import script from "./KmNextRevision.vue?vue&type=script&lang=js"
export * from "./KmNextRevision.vue?vue&type=script&lang=js"
import style0 from "@/styles/styled_cell.less?vue&type=style&index=0&id=79e8bc5a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e8bc5a",
  null
  
)

export default component.exports